/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Only provided for WebhookType==TransactionReport
 * @export
 * @interface TransactionReportMetadata
 */
export interface TransactionReportMetadata {
    /**
     * Report period
     * @type {string}
     * @memberof TransactionReportMetadata
     */
    period?: TransactionReportMetadataPeriodEnum;
    /**
     * true to return completed transactions only, that ended between dateFrom-dateTo. False to include ongoing transactions
     * @type {boolean}
     * @memberof TransactionReportMetadata
     */
    transactionsEndedWithinRangeOnly?: boolean;
}

/**
 * @export
 */
export const TransactionReportMetadataPeriodEnum = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    Annually: "Annually",
} as const;
export type TransactionReportMetadataPeriodEnum =
    (typeof TransactionReportMetadataPeriodEnum)[keyof typeof TransactionReportMetadataPeriodEnum];

/**
 * Check if a given object implements the TransactionReportMetadata interface.
 */
export function instanceOfTransactionReportMetadata(
    value: object,
): value is TransactionReportMetadata {
    return true;
}

export function TransactionReportMetadataFromJSON(
    json: any,
): TransactionReportMetadata {
    return TransactionReportMetadataFromJSONTyped(json, false);
}

export function TransactionReportMetadataFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TransactionReportMetadata {
    if (json == null) {
        return json;
    }
    return {
        period: json["period"] == null ? undefined : json["period"],
        transactionsEndedWithinRangeOnly:
            json["transactionsEndedWithinRangeOnly"] == null
                ? undefined
                : json["transactionsEndedWithinRangeOnly"],
    };
}

export function TransactionReportMetadataToJSON(
    value?: TransactionReportMetadata | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        period: value["period"],
        transactionsEndedWithinRangeOnly:
            value["transactionsEndedWithinRangeOnly"],
    };
}
